const initialState = {
  isRequestingMotivosAbandono: true,
  motivosAbandono: [],
  motivoAbandono: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_MOTIVO_ABANDONO':
      return {
        ...state,
        motivoAbandono: action.motivoAbandono || null
      }
    case 'REQUEST_MOTIVOS_ABANDONO':
      return {
        ...state,
        isRequestingMotivosAbandono: true
      }
    case 'RECEIVE_MOTIVOS_ABANDONO':
      return {
        ...state,
        isRequestingMotivosAbandono: false,
        motivosAbandono: action.motivosAbandono
      }
    default:
      return state
  }
}
